import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { chapterApi } from '@/api/chapterApi'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { friendlyMessage } from '@/api/http'

export function CreatorReview({ chapterId, assetId, onReviewed }: { chapterId: string; assetId: string; onReviewed: () => Promise<void> }) {
 const { t } = useTranslation()
 const [reason, setReason] = useState('')
 const client = useQueryClient()
 const review = useMutation({
  mutationFn: (action: 'approve' | 'reject') => chapterApi.reviewAsset(chapterId, assetId, action, reason.trim()),
  onSuccess: async () => {
   toast.success(t('creatorReview.saved'))
   await Promise.all([onReviewed(), client.invalidateQueries({queryKey: ['page-compose-preflight', chapterId]})])
  },
  onError: (error) => toast.error(friendlyMessage(error, t('common.serviceError'))),
 })
 return <div className="flex flex-wrap items-center gap-2">
  <Input aria-label={t('creatorReview.reason')} placeholder={t('creatorReview.reason')} value={reason} onChange={e => setReason(e.target.value)} disabled={review.isPending} />
  <Button type="button" size="sm" disabled={review.isPending} onClick={() => review.mutate('approve')}>{t('creatorReview.approve')}</Button>
  <Button type="button" size="sm" variant="outline" disabled={review.isPending || !reason.trim()} onClick={() => review.mutate('reject')}>{t('creatorReview.reject')}</Button>
 </div>
}
